import { UuidCollectionViewModel } from '../prothesis-base-api-view-models/uuid-collection.view-model';
import { UuidViewModel } from '../prothesis-base-api-view-models/uuid.view-model';

export class ViewModelHelper {
  public static toUuidCollectionViewModel(uuids: string[] | null | undefined): UuidCollectionViewModel {
    const uuidViewModels: UuidViewModel[] = [];
    uuids!.forEach((uuid) => {
      uuidViewModels.push({
        uuid: uuid,
      });
    });
    const uuidCollectionViewModel = new UuidCollectionViewModel();
    uuidCollectionViewModel.uuids = uuidViewModels;
    return uuidCollectionViewModel;
  }

  public static toUuidViewModels(uuids: string[] | null | undefined): UuidViewModel[] {
    const uuidViewModels: UuidViewModel[] = [];
    uuids!.forEach((uuid) => {
      uuidViewModels.push({
        uuid: uuid,
      });
    });
    return uuidViewModels;
  }
}
